/** Auth user token key */
export const AUTH_USER_TOKEN_KEY = 'ReactAmplify.TokenKey';

export const CONSTANTS = {
	REGEX: {
		EMAIL:
			/^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,
		EMAIL_NULL:
			/^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$|^$/,
		PASSWORD: /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)[a-zA-Z\d]{8,}$/,
		DECIMAL: /^\d{0,9}(\.\d{0,2})?$/,
		DECIMALWIHNEGATIVE: /^-?\d{0,9}(\.\d{0,2})?$/,
		COMMENTS:
			/^([a-zA-Z0-9ñÑáéíóúÁÉÍÓÚ(\s@"'#$%&/()=_;,.:[\]\-*+)]+(?![?])){5,}$/,
		COMMENTS_NO_MIN:
			/^([a-zA-Z0-9ñÑáéíóúÁÉÍÓÚ\s@"'#$%&/()=_;,.:[\]\-*+)]+(?![?]))$/,
		COMMENTS_EMPTY:
			/^([a-zA-Z0-9ñÑáéíóúÁÉÍÓÚ\s@"'#$%&/()=_;,.:[\]\-*+)]*(?![?]))$/,
		NO_SPECIAL: /^[a-zA-Z0-9ñÑáéíóúÁÉÍÓÚ\s@"'#$%&/()=_;,.:[\]\-*+]*$/,
	},
	MESSAGE: {
		NO_RESULTS_FOUND: 'No se encontraron resultados',
		SUCCESS: 'Operación exitosa',
	},
	VALIDATION: {
		REQUIRED: 'Es requerido',
		EMAIL: 'E-mail inválido',
		LIMIT_MAX_15: 'El límite máximo es 15 caracteres',
		LIMIT_MAX_50: 'El límite máximo es 50 caracteres',
		LIMIT_MAX_100: 'El límite máximo es 100 caracteres',
		LIMIT_MAX_200: 'El límite máximo es 200 caracteres',
		LIMIT_MIN_10: 'Debe tener al menos 10 caracteres',
		LIMIT_MIN_4: 'Debe tener al menos 4 caracteres',
		COMENTARIOCARITA: 'Debe seleccionar el nivel de satisfacción',
		DOCUMENT: 'El documento debe tener al menos 8 digitos',
		COMMENTS: 'Debe tener caracteres validos',
		SUCCESS: 'Se encontraron resultados',
	},
	PUNTAJES: [
		{ id: 0, texto: '0' },
		{ id: 1, texto: '1' },
		{ id: 2, texto: '2' },
		{ id: 3, texto: '3' },
		{ id: 4, texto: '4' },
		{ id: 5, texto: '5' },
	],
};

export const ESTADOS_PROYECTO = {
	TODOS: { id: '-1', texto: '- Todos -' },
	ACTIVO: { id: '1', texto: 'Activo' },
	SIN_TALENTO: { id: '2', texto: 'Sin Talentos' },
	CERRADO: { id: '0', texto: 'Cerrado' },
};

export const ESTADOS_TALENTO = {
	TODOS: { id: '', texto: '' },
	ACTIVO: { id: 'Activo', texto: 'Activo' },
	INACTIVO: { id: 'Inactivo', texto: 'Inactivo' },
	SOLICITADO: { id: 'Solicitado', texto: 'Solicitado' },
	APROBADO_EXECUTION: { id: 'Aprobado Execution', texto: 'Aprobado Execution' },
	SELECCIONADO: { id: 'Seleccionado', texto: 'Seleccionado' },
	EN_PROGRESO: { id: 'En progreso', texto: 'En progreso' },
	REGISTRADO: { id: 'Registrado', texto: 'Registrado' },
	CESA_MES_ACTUAL: { id: 'Cesa mes actual', texto: 'Cesa mes actual' },
	RECHAZADO: { id: 'Rechazado', texto: 'Rechazado' },
};
